import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../store';
import { setToken } from '../store/authSlice';
import { trackEvent, setAnalyticsUserFromToken } from '../utils/analytics';

export const OAuthCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const error = params.get('error');

    if (token) {
      dispatch(setToken(token));
      setAnalyticsUserFromToken(token);
      trackEvent('login_success', { method: 'oauth' });
      navigate('/dashboard', { replace: true });
    } else {
      trackEvent('login_error', { method: 'oauth', reason: error || 'oauth_failed' });
      navigate('/login?error=' + (error || 'oauth_failed'), { replace: true });
    }
  }, []);

  return (
    <div className="auth-page">
      <div className="term-panel">
        <div className="term-panel__bar">
          <span className="term-panel__bar-dot" />
          <span className="term-panel__bar-dot" />
          <span className="term-panel__bar-dot" />
          <span className="term-panel__bar-title">auth</span>
        </div>
        <div className="term-panel__body">
          <p style={{ fontFamily: 'Courier New', fontSize: '0.75rem', color: 'var(--px-text-dim)', letterSpacing: '1px' }}>
            &gt; signing in...
          </p>
        </div>
      </div>
    </div>
  );
};
